import {PhoneNumber} from './PhoneNumber';

export type PublicContacts = {
  phoneNumber: PhoneNumber | null;
  emailAddress: string | null;
  website: string | null;
};
